import { SalonInquiryBannerTab } from 'types';
import { pushDataLayer } from './googletag';

export function trackSalonInquiryBannerClick(
  bannerTab: SalonInquiryBannerTab,
  userId?: number,
): void {
  pushDataLayer({
    event: 'salon_inquiry_banner_click',
    banner_tab: bannerTab,
    user_id: userId != null ? `${userId}` : '',
  });
}
